import React from "react";
import StatCard from "../components/StatCard";
import InventoryChart from "../components/InventoryChart";
import RecentActivity from "../components/RecentActivity";
import Card1 from "../assets/dashboard/card1.svg";
import Card2 from "../assets/dashboard/card2.svg";

import Card3 from "../assets/dashboard/card3.svg";
import Card4 from "../assets/dashboard/card4.svg";
import HeaderInfo from "../components/common/HeaderInfo";
import { useGetDashboardStatsQuery } from "../store/api";

export default function Dashboard() {

   const { data, isLoading, isFetching } = useGetDashboardStatsQuery();
   const stats = data?.data;
   const loading = isLoading || isFetching;
  const card_data = [
    {
      icon: Card1,
      label: "Total Inventory",
      value: loading ? "..." : stats?.totalInventory ?? 0,
      bg: "#E2E2FF8C",
    },
    {
      icon: Card2,
      label: "Active Requests",
      value: loading ? "..." : stats?.activeRequests ?? 0,
      bg: "#D8FFD88C",
    },
    {
      icon: Card3,
      label: "Approved Today",
      value: loading ? "..." : stats?.approvedToday ?? 0,
      bg: "#F9FFD8BA",
    },
    {
      icon: Card4,
      label: "Low Stock Alerts",
      value: loading ? "..." : stats?.lowStockAlerts ?? 0,
      bg: "#FFE8E880",
    },
  ];
  return (
    <div className="pt-9 px-6 xl:pl-7 xl:pr-10 min-h-screen pb-10 md:pb-20 xl:pb-40">
      <HeaderInfo title="Overview" desc=" Everything is looking good today." />

      <div className="mt-6 lg:mt-9 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
        {card_data.map((card, idx) => (
          <StatCard key={idx} data={card} />
        ))}
      </div>
      <div className="flex flex-col xl:flex-row gap-4  xl:gap-[22px] mt-6 xl:mt-9">
        <div className="xl:max-w-[707px] w-full">
          <InventoryChart />
        </div>
        <div className="flex-1">
          {" "}
          <RecentActivity data={stats?.recentActivity || []}
            loading={loading} />
        </div>
      </div>
    </div>
  );
}
